import React from 'react';
import { SpecialZoomLevel, Viewer } from '@react-pdf-viewer/core';
import { Worker } from '@react-pdf-viewer/core';
import { ScrollMode, ViewMode } from '@react-pdf-viewer/core';
import PrismaZoom from 'react-prismazoom';
import PageList from '../icons/PageList';
import ExitFullScreen from '../icons/ExitFullScreen';
// Import styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

import useFullScreenPDFReader from './useFullScreenPDFReader';
import { WORKER_URL } from '../../../utils/constants';

const PDFReader = ({ pdfUrl }) => {
  const {
    defaultLayoutPluginInstance,
    isFullScreenMode,
    currentPage,
    totalPages,
    setIsFullScreenMode,
    isDocumentLoaded,
    setIsDocumentLoaded,
  } = useFullScreenPDFReader();

  if (isFullScreenMode) {
    return (
      <div className="full-screen-container">
        {isDocumentLoaded && (
          <>
            <div className="top-20 right-25 position-fixed zIndex-1">
              <ExitFullScreen
                onClick={() => {
                  setIsFullScreenMode(false);
                  setIsDocumentLoaded(false);
                }}
              />
            </div>
            <div className="top-20 left-25 position-fixed zIndex-1">
              <div
                style={{
                  padding: '10px 15px',
                }}
                className="background-white black-border-1 border-radius-7 d-flex justify-center align-items-center gap-10"
              >
                <PageList />
                <div>
                  Page{' '}
                  <b>
                    {currentPage} / {totalPages}
                  </b>
                </div>
              </div>
            </div>
          </>
        )}
        <PrismaZoom>
          <Worker workerUrl={WORKER_URL}>
            <div className="pdf-viewer-container">
              <Viewer
                fileUrl={pdfUrl}
                plugins={[defaultLayoutPluginInstance]}
                renderError={(error) => {
                  return <>Failed to Load PDF</>;
                }}
                defaultScale={SpecialZoomLevel.PageWidth}
                viewMode={ViewMode.SinglePage}
                scrollMode={ScrollMode.Vertical}
                onDocumentLoad={(e) => {
                  setIsDocumentLoaded(true);
                }}
              />
            </div>
          </Worker>
        </PrismaZoom>
      </div>
    );
  }

  return (
    <Worker workerUrl={WORKER_URL}>
      <div className="h-70vh">
        <Viewer
          fileUrl={pdfUrl}
          plugins={[defaultLayoutPluginInstance]}
          renderError={(error) => {
            return <>Failed to Load PDF</>;
          }}
          defaultScale={SpecialZoomLevel.PageFit}
          viewMode={ViewMode.SinglePage}
          scrollMode={ScrollMode.Horizontal}
        />
      </div>
    </Worker>
  );
};

export default PDFReader;
